var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyTrainings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.1 199.1",
    style: {
      enableBackground: "new 0 0 199.1 199.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008FC2;}\n\t.st1{fill:#9DCEE3;}\n\t.st2{fill:#C2E5F0;}\n\t.st3{fill:#5CB28C;}\n\t.st4{fill:#374A5E;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#E7AF52;}\n\t.st7{fill:#278BC8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.5,
    cy: 99.5,
    r: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,47c13.6,0,26.4,3,37.9,8.5c-15.4-27-44.3-45.1-77.6-45.1c-49.3,0-89.3,40-89.3,89.3 c0,35.7,21,66.5,51.3,80.8c-7.4-13-11.7-28.1-11.7-44.1C49.9,86.9,89.9,47,139.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.8,99.5c0-16.1-4.3-31.1-11.7-44.1C165.6,50,152.7,47,139.2,47c-49.3,0-89.3,40-89.3,89.3 c0,16.1,4.3,31.1,11.7,44.1c11.5,5.4,24.4,8.5,37.9,8.5C148.8,188.8,188.8,148.8,188.8,99.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 148.5,
    y: 69.2,
    className: "st3",
    width: 1.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,72.5l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C110.6,72.3,125.2,67.7,137.9,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,80.2l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C110.6,80,125.2,75.4,137.9,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,87.9l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C110.6,87.6,125.2,83,137.9,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,95.5l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C110.6,95.3,125.2,90.7,137.9,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,103.2l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C110.6,103,125.2,98.4,137.9,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,110.9l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C110.6,110.7,125.2,106,137.9,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,118.5l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C110.6,118.3,125.2,113.7,137.9,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.9,118.5c-12.8-4.8-27.3-0.2-27.9,0l1,3.2c0.1,0,14-4.5,25.7,0L137.9,118.5z M111.1,114.1 c0.1,0,14-4.5,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L111.1,114.1z M111.1,106.4c0.1,0,14-4.4,25.7,0l1.2-3.2 c-12.8-4.8-27.3-0.2-27.9,0L111.1,106.4z M111.1,98.8c0.1,0,14-4.5,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L111.1,98.8z  M111.1,91.1c0.1,0,14-4.5,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L111.1,91.1z M111.1,83.4c0.1,0,14-4.4,25.7,0l1.2-3.2 c-12.8-4.8-27.3-0.2-27.9,0L111.1,83.4z M111.1,75.8c0.1,0,14-4.5,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L111.1,75.8z  M101,63.4L99.9,63c-0.2-0.1-0.4-0.1-0.6-0.2c8.4-3.1,16.9-4.7,25.4-4.7c14.8,0,24.2,4.8,24.6,5l0.9,0.5v5.7h-1.7v3.4h1.7 v61.7l-2.2-0.6c-7.6-2.1-15.6-3.2-23.9-3.2c-11.4,0-20.1,2.1-23.2,2.9v-1.3V63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101,133.3c3-0.8,11.8-2.9,23.2-2.9c8.3,0,16.3,1.1,23.9,3.2l2.2,0.6V72.7h3.7v64.9H101v-3.2V133.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.6,
    y: 137.6,
    className: "st4",
    width: 3.4,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M101,133.3v1l-1.7-0.5l0.5-0.2C99.9,133.7,100.3,133.5,101,133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101,132.1v1.3c-0.7,0.2-1.1,0.3-1.2,0.3l-0.5,0.2l-0.5-0.2c0,0-0.4-0.1-1.2-0.3v-1.3H101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.6,63.4l1.1-0.4c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0.1,0.4,0.1,0.6,0.2l1.1,0.4v68.6h-3.4V63.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "97.6,134.4 99.3,133.8 101,134.4 101,137.6 97.6,137.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.3,133.8l-1.7,0.5v-1c0.8,0.2,1.2,0.3,1.2,0.3L99.3,133.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,72.5L88,75.7c-11.6-4.4-25.5,0-25.7,0l-1-3.2C61.9,72.3,76.4,67.7,89.2,72.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,80.2L88,83.4c-11.6-4.4-25.5,0-25.7,0l-1-3.2C61.9,80,76.4,75.4,89.2,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,87.9L88,91.1c-11.6-4.4-25.5,0-25.7,0l-1-3.2C61.9,87.6,76.4,83,89.2,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,95.5L88,98.7c-11.6-4.4-25.5,0-25.7,0l-1-3.2C61.9,95.3,76.4,90.7,89.2,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,103.2l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C61.9,103,76.4,98.4,89.2,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,110.9l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C61.9,110.7,76.4,106,89.2,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,118.5l-1.2,3.2c-11.6-4.4-25.5,0-25.7,0l-1-3.2C61.9,118.3,76.4,113.7,89.2,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.2,118.5c-12.8-4.8-27.3-0.2-27.9,0l1,3.2c0.1,0,14-4.5,25.7,0L89.2,118.5z M62.3,75.8 c0.1,0,14-4.5,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L62.3,75.8z M62.3,83.4c0.1,0,14-4.4,25.7,0l1.2-3.2 c-12.8-4.8-27.3-0.2-27.9,0L62.3,83.4z M62.3,98.8c0.1,0,14-4.5,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L62.3,98.8z  M62.3,114.1c0.1,0,14-4.5,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L62.3,114.1z M62.3,91.1c0.1,0,14-4.5,25.7,0l1.2-3.2 c-12.8-4.8-27.3-0.2-27.9,0L62.3,91.1z M62.3,106.4c0.1,0,14-4.4,25.7,0l1.2-3.2c-12.8-4.8-27.3-0.2-27.9,0L62.3,106.4z  M97.6,133.3c-3.1-0.8-11.8-2.9-23.2-2.9c-8.3,0-16.3,1.1-23.9,3.2l-2.1,0.6V71h1.7v-3.4h-1.7v-4l0.9-0.5 c0.4-0.2,9.8-5,24.6-5c8.5,0,17,1.6,25.4,4.7c-0.2,0-0.4,0.1-0.6,0.2l-1.1,0.4v68.6V133.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.4,
    y: 67.6,
    className: "st5",
    width: 1.7,
    height: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.6,133.7c7.6-2.1,15.6-3.2,23.9-3.2c11.3,0,20.1,2.1,23.2,2.9v1v3.2H45.1V71h3.3v63.3L50.6,133.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "45.1,137.6 97.6,137.6 97.6,139.3 101,139.3 101,137.6 153.9,137.6 153.9,72.7 150.2,72.7  150.2,69.2 157.3,69.2 157.3,141 41.7,141 41.7,67.6 48.4,67.6 48.4,71 45.1,71  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 99.3,
    y1: 62.8,
    x2: 99.3,
    y2: 133.7
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.9,72.5v49.2c0,0,14.9-4.5,27.9,0V72.5C138.8,72.5,128.2,66.6,110.9,72.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 128.5,
    cy: 84.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "114.6,108.7 128.5,98.2 131.1,114.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTrainings);
export default __webpack_public_path__ + "static/media/my_trainings.e93a44709637c64646d3e38cc291676a.svg";
export { ForwardRef as ReactComponent };